export default __webpack_public_path__ + "dc3ca390023d2447e5f90c6b135bb1bc.png";